import React from 'react';
import { useNavigate } from 'react-router-dom';
import rswebsite from "../assets/rswebsitelogo.jpg";
import rsblog from "../assets/rsblog.png";

const DashboardSelection = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-blue-50">
      <div className="container mx-auto px-6 py-20">
        <div className="relative mb-16">
          <div className="absolute inset-0 bg-gradient-to-r from-sky-100/50 via-white/50 to-blue-100/50 rounded-3xl blur-2xl"></div>
          <div className="relative bg-white/30 backdrop-blur-md rounded-3xl p-8 border border-white/50 shadow-xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl text-center font-medium bg-gradient-to-r from-sky-600 to-blue-600 bg-clip-text text-transparent mb-6 break-words leading-tight">
              What would you like to do today?
            </h1>
            <p className="text-lg md:text-xl text-center text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Please select your dashboard
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* English Dashboard Card */}
          <div 
            className="bg-white rounded-2xl shadow-md overflow-hidden cursor-pointer"
            onClick={() => navigate('/dashboard')}
          >
            <div className="p-8 flex flex-col items-center justify-center">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6 bg-sky-100 shadow-lg">
                <img 
                  src={rswebsite} 
                  alt="RS Website Logo" 
                  className="w-14 h-14 rounded-full object-cover"
                />
              </div>
              
              <h2 className="text-2xl font-semibold mb-3 text-center text-sky-700">
              RajendraShende.com
              </h2>
              
              <p className="text-gray-600 mb-6 text-center">
              Portfolio Website
              </p>
              
              <button className="bg-sky-500 hover:bg-sky-600 text-white px-6 py-3 rounded-lg transition-colors duration-300 shadow-md">
                Go to Dashboard
              </button>
            </div>
          </div>
          
          {/* Marathi Dashboard Card */}
          <div 
            className="bg-white rounded-2xl shadow-md overflow-hidden cursor-pointer"
            onClick={() => navigate('/marathi-dashboard')}
          >
            <div className="p-8 flex flex-col items-center justify-center">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-6 bg-red-100 shadow-lg">
                <img 
                  src={rsblog} 
                  alt="RS Blog Logo" 
                  className="w-14 h-14 rounded-full object-cover"
                />
              </div>
              
              <h2 className="text-2xl font-semibold mb-3 text-center text-red-700">
                RajendraShende.blog
              </h2>
              
              <p className="text-gray-600 mb-6 text-center">
                Marathi Blogs Website
              </p>
              
              <button className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg transition-colors duration-300 shadow-md">
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSelection;